import React, { useState } from "react";

import "./contactSupport.scss";

import supportIcon from "../../assets/images/contact_support.png";
import {
  isMobile,
  navigateToURL,
} from "../../bridges/BridgeServices";
import Chatbot from "../Chatbot/Chatbot";

const ContactSupport = () => {
  const [shouldOpenChatbot, setOpenChatbot] = useState(
    false
  );
  return (
    <>
      <div
        className="contact-support"
        onClick={() => {
          if (isMobile()) {
            navigateToURL("CHATBOT");
          } else {
            setOpenChatbot(true);
            setTimeout(() => {
              setOpenChatbot(false);
            }, 1000);
          }
        }}
      >
        <div className="contact-support-icon">
          <img src={supportIcon} />
        </div>
        <div className="contact-support-content">
          Contact Support
        </div>
      </div>
      <Chatbot shouldOpenChatbot={shouldOpenChatbot} />
    </>
  );
};

export default ContactSupport;
